import { render } from "./Last5.vue?vue&type=template&id=82eb9afa&scoped=true"
import script from "./Last5.vue?vue&type=script&lang=js"
export * from "./Last5.vue?vue&type=script&lang=js"

import "./Last5.vue?vue&type=style&index=0&id=82eb9afa&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82eb9afa"]])

export default __exports__